<template>
  <div class="popup-container">
    <div class="popup-header">
      <slot name="header">
      </slot>
    </div>

    <div class="popup-body" :class="styleBody()">
      <slot>
      </slot>
    </div>

    <div class="popup-footer" @click="cancel()">
      <slot name="footer">
        {{ footerButtonLabel }}
      </slot>
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  props: {
    buttonLabel: {
      type: String
    },
    bodyFlex: {
      type: Boolean
    }
  },

  computed: {
    footerButtonLabel: function () {
      if (this.buttonLabel) {
        return this.$l[this.buttonLabel]
      }
      return this.$l.cancel
    }
  },

  methods: {
    styleBody: function () {
      if (this.bodyFlex) {
        return { 'popup-body_flex': true }
      }
    },
    cancel: function () {
      this.$store.dispatch('popup/hide', null, { root: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  &-container {
    display: flex;
    min-height: 100%;
    flex-direction: column;
  }

  &-header {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $peter-liver;
    color: white;
  }

  &-body {
    flex-grow: 1;
    overflow: auto;
    height: 0;
    &_flex {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      overflow: auto;
      height: 0;
    }
  }

  &-footer {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid $concrete;
    color: $peter-liver;
    &:hover {
      background-color: rgba(0, 0, 0, 0.2)
    }
  }
}
</style>
